/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import type { App } from 'vue'
import PrimeVue from 'primevue/config'
import { InputTextWrapper } from '@/core/components'
import { locales } from './locales'
import {
  readStoredUserLocale,
  resolveDeviceLocale,
} from '../i18n/resolveDeviceLocale'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'

import '@/core/assets/css/tailwind.css'
import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
  },
})

const config = {
  ripple: true,
  theme: {
    preset: MyPreset,
    options: {
      cssLayer: false,
    },
  },
}

export const loadPrimeVue = (app: App) => {
  const initialLocale = readStoredUserLocale() ?? resolveDeviceLocale()

  app.use(PrimeVue, {
    ...config,
    locale: locales[initialLocale],
  })

  app.use(ToastService)
  app.use(ConfirmationService)
  app.component('InputTextWrapper', InputTextWrapper)
}

export default PrimeVue
